import React from 'react';
import { optimizarFoto } from '../utils/imagen';
import { SUBTITULO_DEFECTO, BOTON_DEFECTO } from '../utils/tiendaDiseno';

// Portada de la tienda en línea según el diseño elegido (plantilla, fondo,
// botón, alineación y enfoque de la foto). La usan el catálogo público y la
// vista previa de Configuración. Se adapta al ANCHO DE SU CAJA (container
// queries), así la vista previa de "computadora" se ve igual que la real.
export default function PortadaTienda({ diseno, nombre, logo, foto, titulo, onVer }) {
  const plantilla = foto ? diseno.plantilla : 'texto';
  const conFoto = plantilla !== 'texto';
  return (
    <div className="cb-portada-caja">
      <section className={`cb-portada p-${plantilla} f-${diseno.fondo} a-${diseno.alineacion}`}>
        {conFoto && (
          <div className="cb-portada-foto" role="img" aria-label={`Foto de ${nombre || 'la tienda'}`}
            style={{ backgroundImage: `url("${optimizarFoto(foto, 1600)}")`, backgroundPosition: `center ${diseno.enfoque}` }} />
        )}
        <div className="cb-portada-texto">
          {!conFoto && logo && <img className="cb-logo-portada" src={optimizarFoto(logo, 200)} alt="" />}
          {nombre && <span className="cb-portada-marca">{nombre}</span>}
          <h1 className="cb-serif">{titulo}</h1>
          <p>{diseno.subtitulo || SUBTITULO_DEFECTO}</p>
          <button type="button" className={`cb-btn b-${diseno.boton}`} onClick={onVer}>{diseno.textoBoton || BOTON_DEFECTO}</button>
        </div>
      </section>
    </div>
  );
}
